import { createApp, h } from 'vue'
import Vuetify from 'vuetify/dist/vuetify.min.js'
import { ja, en } from 'vuetify/locale'

const { createVuetify } = Vuetify
const DriftLightTheme = {
  dark: false,
  colors: {
    primary: '#30227e',
    secondary: '#4a60b0',
    error: '#c93e4c',
    info: '#73b4da',
    success: '#4caf50',
    warning: '#ff9710'
  }
}

export default function vueRenderer(id, component, hasOptionDataId=undefined) {
  const appMount = async () => {
    const target = document.getElementById(id)
    if (target) {
      const props = hasOptionDataId ? { ...target.dataset, ...document.getElementById(hasOptionDataId).dataset } : target.dataset
      const app = createApp({
        render() {
          return h(component, { ...props })
        }
      })
      app.use(createVuetify({
        locale: {
          locale: 'ja',
          fallback: 'en',
          messages: { ja, en }
        },
        theme: {
          defaultTheme: 'DriftLightTheme',
          themes: {
            DriftLightTheme,
          },
        },
        icons: {
          defaultSet: 'mdi'
        }
      }))
      app.mount(target)
    }
  }

  document.addEventListener('turbo:load', async () => {
    appMount()
  })
  document.addEventListener('turbo:render', async () => {
    appMount()
  })

  document.addEventListener("turbo:before-cache", () => {
    const target = document.getElementById(id)
    if (target) {
      target.__vue_app__?.unmount()
    }
  })
}
